import styled from "styled-components";

export const EducationItem = styled.li`
  margin-bottom: 1.2rem;
`;
